import { WithChildren } from "../../types";
import styles from "./InfoMessage.module.css";

type ComponentProps = WithChildren & {
  type?: "info" | "warning" | "success";
  className?: string;
  variant?: "quiet";
};

export const InfoMessage = ({ children, type = "warning", className, variant }: ComponentProps) => (
  <div className={[styles.message, styles[type], variant && styles[variant], className].filter(Boolean).join(" ")}>
    {children}
  </div>
);
